import React, { useState } from "react";
import { Link } from "react-router-dom";
import MeAge from "./MeAge";
import FriendFamilyMemberDetails from "./FriendFamilyMemberDetails";
import Location from "./Location";
import Register from "./Register";

const RegisterSteps = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const goNext = () => {
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const goBack = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  return (
    <div className="register-steps-container">
      <div className="logo-container">
        <Link to="/">
          <img
            src="/will-care-logo-150x150.png"
            alt="Company Logo"
            width="100"
          />
        </Link>
      </div>
      <div className="separator"></div>
      {/* <div className="steps-indicator">
        <div className="step-item">
          <span className={currentStep >= 1 ? "active-step" : ""}>1</span>
        </div>
        <div className="step-item">
          <span className={currentStep >= 2 ? "active-step" : ""}>2</span>
        </div>
        <div className="step-item">
          <span className={currentStep >= 3 ? "active-step" : ""}>3</span>
        </div>
        <div className="step-item">
          <span className={currentStep >= 4 ? "active-step" : ""}>4</span>
        </div>
      </div> */}
      <div className="intro-text">
        <h1>Thanks for that.</h1>
        <p>What's their name?</p>
      </div>
      {currentStep === 1 && <FriendFamilyMemberDetails goNext={goNext} />}
      {currentStep === 2 && <MeAge goNext={goNext} goBack={goBack} />}
      {currentStep === 3 && <Location goNext={goNext} goBack={goBack} />}
      {currentStep === 4 && <Register goBack={goBack} />}
    </div>
  );
};

export default RegisterSteps;
